import { useCallback } from 'react';

import { Button } from 'antd';

import { message } from '@eduzz/ui-antd-theme';

import { trpc } from '@/lib/trpc';

const TestError = () => {
  const { mutate } = trpc.test.triggerError.useMutation({
    retry: false,
    throwOnError: true,
    onError: error => {
      message.error(error.message);
    }
  });

  const emitError = useCallback(() => {
    mutate();
  }, [mutate]);

  return (
    <Button id='test-error-button' onClick={emitError}>
      Click to emit a test error
    </Button>
  );
};

export default TestError;
